import {
  EVENT_SET_PV_FIELDS,
  EVENT_SET_PV_SEEN_STATUS,
  EventSetPvFieldsPayload,
  EventSetPvSeenStatusPayload,
} from '@weblite/ts-action/pv'

import { pvsStorage } from './storage'

import { serverSub } from '$func/subscription'
import { updateRoomLastMessageDebounced } from '$logic/room-last-message'

serverSub.subscribe(
  EVENT_SET_PV_SEEN_STATUS,
  async ({ patches }: EventSetPvSeenStatusPayload) => {
    patches.forEach(async ({ roomId, ...fields }) => {
      const pv = await pvsStorage.get(roomId)
      if (pv.seen < fields.seen) await pvsStorage.set(roomId, fields)
    })
  },
)

serverSub.subscribe(
  EVENT_SET_PV_FIELDS,
  async ({ roomId, fields }: EventSetPvFieldsPayload) => {
    await pvsStorage.set(roomId, fields)
    if (fields && ('firstVisibleIid' in fields || 'lastVisibleIid' in fields))
      await updateRoomLastMessageDebounced(roomId)
  },
)
